import {
  articles,
  categories,
  topics,
  type Article,
  type Category,
  type Topic,
} from "@/mocks/news";

export function getCategory(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategory(slug)?.name ?? "资讯";
}

export function getArticle(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getTopic(id: string): Topic | undefined {
  return topics.find((t) => t.id === id);
}

export function articlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function articlesByTopic(topicId: string): Article[] {
  return articles.filter((a) => a.topicIds.includes(topicId));
}

export function latestArticles(limit?: number): Article[] {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function hotArticles(limit = 6): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function searchArticles(query: string): Article[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return articles.filter(
    (a) =>
      a.title.toLowerCase().includes(q) ||
      a.summary.toLowerCase().includes(q) ||
      a.tags.some((t) => t.toLowerCase().includes(q)),
  );
}

export function relatedArticles(article: Article, limit = 4): Article[] {
  const scored = articles
    .filter((a) => a.id !== article.id)
    .map((a) => {
      let score = 0;
      if (a.category === article.category) score += 3;
      score += a.tags.filter((t) => article.tags.includes(t)).length * 2;
      if (a.topicIds.some((t) => article.topicIds.includes(t))) score += 1;
      return { a, score };
    })
    .filter((item) => item.score > 0)
    .sort((x, y) => y.score - x.score);
  return scored.slice(0, limit).map((item) => item.a);
}

export function formatDate(date: string): string {
  const [y, m, d] = date.split("-");
  if (!y || !m || !d) return date;
  return `${y}年${Number(m)}月${Number(d)}日`;
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}

export function categoryAccent(slug: string): string {
  if (slug === "entertainment") return "bg-accent-100 text-accent-900";
  if (slug === "tech") return "bg-secondary-100 text-secondary-900";
  return "bg-primary-100 text-primary-800";
}